<template>
  <layout-main-inner title="特惠商品">
    <el-button
      slot="action"
      type="primary"
      @click="addLottery">新增特惠商品</el-button>
    <layout-card-wrap hasHeaderSlot>
      <el-form
        slot="form"
        :inline="true"
        class="margin-botton-0">
        <el-form-item>
          <el-radio-group
            v-model="config.status"
            @change="handleCurrentChange(1)">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="0">待发布</el-radio-button>
            <el-radio-button :label="1">已发布</el-radio-button>
            <el-radio-button :label="2">已结束</el-radio-button>
            <el-radio-button :label="3">已关闭</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          :resizable="false"
          label="商品名称"
          prop="goodsName"></el-table-column>
        <el-table-column
          label="原价"
          width="80"
          :resizable="false"
          :formatter="(row)=> '¥' + row.price"
          prop="price">
        </el-table-column>
        <el-table-column
          label="特惠价"
          width="80"
          :resizable="false"
          :formatter="(row)=> '¥' + row.seckillPrice"
          prop="seckillPrice">
        </el-table-column>
        <el-table-column
          label="特惠库存"
          :resizable="false"
          prop="seckillStorageCount"
          width="90">
        </el-table-column>
        <el-table-column
          label="每人限购"
          :resizable="false"
          prop="seckillCountLimit"
          width="80">
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="参与会员折扣"
          width="100">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.memberDiscount===1"
              type="success">开启</el-tag>
            <el-tag
              v-if="row.memberDiscount===0"
              type="danger">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="活动状态"
          width="80"
          :resizable="false">
          <template slot-scope="{row}">
            <el-tag
              v-if="row.status===0"
              type="info">待上线</el-tag>
            <el-tag
              v-if="row.status===1"
              type="success">进行中</el-tag>
            <el-tag
              v-if="row.status===2"
              type="warning">已结束</el-tag>
            <el-tag
              v-if="row.status===3"
              type="danger">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="活动时间"
          width="250">
          <template slot-scope="{row}">
            <div v-if="row.status !== 0">
              {{ row.startTime | dateformat() }} - {{ row.closeTime | dateformat() }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="160">
          <template slot-scope="{row, $index}">
            <el-popover
              v-show="row.status === 0"
              :key="$index"
              :ref="`popover_${$index}`"
              title="选择活动时间"
              trigger="click"
              placement="right">
              <div style="margin:10px">
                <el-date-picker
                  v-model="row.closeTimeBak"
                  style="width: 340px"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  placeholder="选择活动时间">
                </el-date-picker>
                <div style="margin-top:10px;text-align:right">
                  <el-button
                    type="primary"
                    @click="() => { publishLottery(row,`popover_${$index}`) }">确定</el-button>
                </div>
              </div>
              <el-button
                slot="reference"
                style="margin-right:10px"
                type="primary">上线</el-button>
            </el-popover>
            <el-dropdown>
              <el-button
                type="info">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.status === 0"
                  @click.native="editLottery(row)">编辑</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 0"
                  @click.native="deleteLottery(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 1 || row.status === 2"
                  @click.native="closeottery(row)">关闭</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button
              v-if="row.status===0"
              type="text"
              style="margin-left:10px"
              @click="editLottery(row)">编辑</el-button>
            <el-button
              v-if="row.status===0"
              type="text"
              @click="deleteLottery(row)">删除</el-button>
            <el-button
              v-if="row.status===1 || row.status===2"
              type="text"
              @click="closeottery(row)">关闭</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
      <discount-reg-modal
        ref="modal"
        :callback="fetchList" />
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import DiscountRegModal from '../busi/discount-reg-modal.vue'
// import moment from 'moment'
export default {
  name: 'DiscountList',
  components: { DiscountRegModal },
  data() {
    return {
      loading: true,
      pickerOptions: {
        disabledDate: (date) => {
          console.log(date)
          return false
          // return date <= Date.now()
        }
      },
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        status: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    addLottery() {
      this.$refs.modal.toggleModal(true)
    },
    editLottery(row) {
      this.$refs.modal.fetch({
        vendorId: row.vendorId,
        seckillGoodsId: row.seckillGoodsId
      })
    },
    closeottery(row) {
      this.$confirm('您确定关闭该特惠商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('discount/closeseckillgoods', {
            payload: {
              vendorId: row.vendorId,
              seckillGoodsId: row.seckillGoodsId
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    deleteLottery(row) {
      this.$confirm('您确定删除该特惠商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('discount/deleteseckillgoods', {
            payload: {
              vendorId: row.vendorId,
              seckillGoodsId: row.seckillGoodsId
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    publishLottery(row) {
      console.log(row)
      if (!row.closeTimeBak) {
        this.$message.error('请选择发布时间')
        return
      }
      this.$confirm('您确定发布该特惠商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch(`discount/publishseckillgoods`, {
            payload: {
              vendorId: row.vendorId,
              seckillGoodsId: row.seckillGoodsId,
              startTime: +row.closeTimeBak[0],
              closeTime: +row.closeTimeBak[1]
            },
            success: () => {
              this.loading = false
              this.handleCurrentChange(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('discount/getseckillgoodslist', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
